import {
  getTigerXHistoryKeysTranslationsHint,
  TranslationHintHistoryTigerX,
} from '@/pages/History/components/HistoryTrade/HistoryTrade.translations/tigerXHistoryDictionary'
import { QuestionButton } from '@/ui/atoms/QuestionButton'

export const getHintHistoryTigerX = (key: TranslationHintHistoryTigerX) => {
  const translationsText = getTigerXHistoryKeysTranslationsHint(key)

  if (!translationsText) {
    return null
  }
  return <QuestionButton text={translationsText} placement="left" tmmHintIcon />
}
